import { useState, useEffect } from "react"

const tick = (count, setCount, callback) => {
  useEffect(() => {
    window.setTimeout(() => {
      setCount(count + 1)
      callback()
    }, 5000)
  }, [count])
}

const fetchTopic = async path => {
  const response = await fetch(path)
  const data = await response.json()
  return data.notification
}

const update = async path => {
  return await fetchTopic(path)
}

let path, count, setCount

export default class Updater {
  constructor(_path) {
    path = _path
    ;[count, setCount] = useState(0)
  }

  async run(callback) {
    tick(count, setCount, async () => {
      const data = await update(path)
      callback(data)
    })
  }

  idle() {
    useEffect(() => {}, [count])
  }
}
